import { NavigationContainer } from "@react-navigation/native";
import react from "react";
import { Text, StyleSheet, TouchableOpacity, ScrollView, Image } from "react-native";
import { View, Dimensions } from "react-native";
import { useTranslation } from 'react-i18next';
import { i18n } from '../assets/lang/i18next';

const SelectDevice = props => {
    const { t, i18n } = useTranslation();

    return (
        <ScrollView showsHorizontalScrollIndicator={false} style={{ backgroundColor: '#ebecec' }}>
            <View style={{ backgroundColor: '#ebecec', flex: 1, justifyContent: 'center', margin: 10 }}>

                <View style={{ justifyContent: 'center', flex: 1, flexDirection: 'row' }}>
                    <Text style={{ fontFamily: 'IranSans', fontWeight: 900, fontSize: 14, marginTop: 10, marginBottom: 10 }}>{t('selectdevice')}</Text>
                </View>


                <View style={styles.listRow} >
                    <TouchableOpacity onPress={() => props.navigation.navigate('ُSelectDevice_Evaprator')} style={[styles.touchable,{flexDirection:i18n.language=="en"?'row-reverse':'row'}]}>
                        <Image resizeMode="contain" source={require('../assets/images/selectdevice/1.png')} style={styles.img} />
                        <Text style={styles.title}>{t('Evaporator')}</Text>
                    </TouchableOpacity>
                </View>


                <View style={styles.listRow} >
                    <TouchableOpacity onPress={() => props.navigation.navigate('ُSelectDevice_EvapratorChandMedareh')} style={[styles.touchable,{flexDirection:i18n.language=="en"?'row-reverse':'row'}]}>
                        <Image resizeMode="contain" source={require('../assets/images/selectdevice/2.png')} style={styles.img} />
                        <Text style={styles.title}>{t('multiCircuitsEvaporators')}</Text>
                    </TouchableOpacity>
                </View>

                <View style={styles.listRow} >
                    <TouchableOpacity onPress={() => props.navigation.navigate('ُSelectDevice_EvapratorArtec')} style={[styles.touchable,{flexDirection:i18n.language=="en"?'row-reverse':'row'}]}>
                        <Image resizeMode="contain" source={require('../assets/images/selectdevice/3.png')} style={styles.img} />
                        <Text style={styles.title}>{t('ArtecEvaporator')}</Text>
                    </TouchableOpacity>
                </View>



                <View style={styles.listRow} >
                    <TouchableOpacity onPress={() => props.navigation.navigate('ُSelectDevice_CondO45')} style={[styles.touchable,{flexDirection:i18n.language=="en"?'row-reverse':'row'}]}>
                        <Image resizeMode="contain" source={require('../assets/images/selectdevice/4.png')} style={styles.img} />
                        <Text style={styles.title}>{t('HorizontalCondenser4&5series')}</Text>
                    </TouchableOpacity>
                </View>


                <View style={styles.listRow} >
                    <TouchableOpacity onPress={() => props.navigation.navigate('ُSelectDevice_CondA45')} style={[styles.touchable,{flexDirection:i18n.language=="en"?'row-reverse':'row'}]}>
                        <Image resizeMode="contain" source={require('../assets/images/selectdevice/5.png')} style={styles.img} />
                        <Text style={styles.title}>{t('StaticCondenser4&5series')}</Text>
                    </TouchableOpacity>
                </View>


                <View style={styles.listRow} >
                    <TouchableOpacity onPress={() => props.navigation.navigate('ُSelectDevice_CondO8')} style={[styles.touchable,{flexDirection:i18n.language=="en"?'row-reverse':'row'}]}>
                        <Image resizeMode="contain" source={require('../assets/images/selectdevice/6.png')} style={styles.img} />
                        <Text style={styles.title}>{t('HorizontalCondenser8series')}</Text>
                    </TouchableOpacity>
                </View>


                <View style={styles.listRow} >
                    <TouchableOpacity onPress={() => props.navigation.navigate('ُSelectDevice_CondA8')} style={[styles.touchable,{flexDirection:i18n.language=="en"?'row-reverse':'row'}]}>
                        <Image resizeMode="contain" source={require('../assets/images/selectdevice/7.png')} style={styles.img} />
                        <Text style={styles.title}>{t('StaticCondenser85series')}</Text>
                    </TouchableOpacity>
                </View>


                <View style={styles.listRow} >
                    <TouchableOpacity onPress={() => props.navigation.navigate('ُSelectDevice_CondArtec')} style={[styles.touchable,{flexDirection:i18n.language=="en"?'row-reverse':'row'}]}>
                        <Image resizeMode="contain" source={require('../assets/images/selectdevice/8.jpg')} style={styles.img} />
                        <Text style={styles.title}>{t('ArtecCondenser')}</Text>
                    </TouchableOpacity>
                </View>



            </View>

        </ScrollView>
    )
}
const styles = StyleSheet.create(
    {
        listRow: {
            height: 70,
            width: '100%',
            padding: 10,
            margin: 4,
            backgroundColor: '#fff',
            color: '#fff',
            borderRadius: 5,
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 0.5 },
            shadowOpacity: 0.7,
            shadowRadius: 2,
        }
        ,
        title: {
            paddingRight: 15,
            padding: 17,
            fontFamily: 'IranSans',
            fontSize: 13.5,
            textAlignVertical: 'middle',


        }
        ,
        img: {
            width: 100,
            height: 60,
            borderRadius: 3,
            resizeMode: 'cover',

        }
        , touchable: {
            justifyContent: 'space-between',
            flex: 1, flexDirection: 'row',
        }
    }
)
export default SelectDevice;